import { Inject, Injectable, Injector } from '@angular/core';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';

import { Utilities_OperationService } from './Utilities.operation.service';
import { Invoices_OperationService } from './Invoices.operation.service';
import { Notifications_OperationService } from './Notifications.operation.service';
import { Inventory_OperationService } from './Inventory.operation.service';
import { FootPrintApiManager_OperationService } from './FootPrintApiManager.operation.service';


@Injectable({ providedIn: 'root' })
export class app_OperationService {

  constructor(
    private injector: Injector,
    private utils: UtilsService,
  ) {
    this.Utilities = this.injector.get(Utilities_OperationService);
    this.Invoices = this.injector.get(Invoices_OperationService);
    this.Notifications = this.injector.get(Notifications_OperationService);
    this.Inventory = this.injector.get(Inventory_OperationService);
    this.FootPrintApiManager = this.injector.get(FootPrintApiManager_OperationService);
  }

    public Utilities: Utilities_OperationService;
    public Invoices: Invoices_OperationService;
    public Notifications: Notifications_OperationService;
    public Inventory: Inventory_OperationService;
    public FootPrintApiManager: FootPrintApiManager_OperationService;
  public app: app_OperationService = this;


  private isAuthorized(operationName: string): Promise<boolean> {
    return this.utils.http.post(`${environment.backendUrl}api/app/operations/${operationName}/isauthorized`, null);
  }
}
